export default {
    LOAD_PRODUCT_DEPTS (state, productdepts) {
        state.items = productdepts
    }
}